import wx from 'weixin-js-sdk'
import '@/store' // 确保 setActivePinia 在此处生效
import { reqWxJsSdkConfig, loginWx, reqUserInfo } from '@/api'
import UserInfo from '@/store/userStore'

// ==================== 微信公众号配置 ====================
const WX_APPID = 'wx227c21dfd0930884'
// OAuth2 回调地址：建议使用“当前站点入口地址”，避免部署到不同域名时仍跳回旧域名
const getWxRedirectUri = () => {
	try {
		const url = new URL(window.location.href)
		// hash 路由无需带 hash；并且不要携带 code/state，避免“分享出去带旧 code”
		url.hash = ''
		url.searchParams.delete('code')
		url.searchParams.delete('state')
		// 只保留站点入口（pathname），不带查询参数
		return `${url.origin}${url.pathname}`
	} catch (e) {
		return window.location.origin + window.location.pathname
	}
}

const readyCallbacks = []
let isReady = false

// ==================== 最小化防死循环：code换openid失败后，短时间内不再自动重定向 ====================
const WX_AUTH_FAIL_AT_KEY = '__wx_auth_fail_at__'
const WX_AUTH_FAIL_COOLDOWN_MS = 5 * 60 * 1000 // 5分钟

const getWxAuthFailAt = () => Number(sessionStorage.getItem(WX_AUTH_FAIL_AT_KEY) || 0)
const setWxAuthFailAt = () => sessionStorage.setItem(WX_AUTH_FAIL_AT_KEY, String(Date.now()))
const clearWxAuthFailAt = () => sessionStorage.removeItem(WX_AUTH_FAIL_AT_KEY)

/** 判断是否在微信浏览器中 */
export const isWeChat = () => /micromessenger/i.test(window.navigator.userAgent || '')

const normalizeConfig = (res) => {
	if (!res) return null
	return res.data || res.result || res
}

export const onWeChatReady = (callback) => {
	if (typeof callback !== 'function') return
	if (isReady) {
		callback()
		return
	}
	readyCallbacks.push(callback)
}

// 初始化微信JSSDK
export const initWeChatSdk = async (url = window.location.href) => {
	if (!isWeChat()) return
	try {
		const cleanUrl = url.split('#')[0]
		// 用表单的方式传递
		const formData = new URLSearchParams()
		formData.append('url', cleanUrl)
		const res = await reqWxJsSdkConfig(formData)
		const config = normalizeConfig(res)
		if (!config) return

		wx.config({
			debug: false,
			appId: config.appId,
			timestamp: config.timestamp,
			nonceStr: config.nonceStr,
			signature: config.signature,
			jsApiList: [
				'updateAppMessageShareData',
				'updateTimelineShareData',
				'onMenuShareAppMessage',
				'onMenuShareTimeline',
			],
		})

		wx.ready(() => {

			isReady = true
			while (readyCallbacks.length) {
				const cb = readyCallbacks.shift()
				if (cb) cb()
			}
			const u = new URL(window.location.href);
			u.searchParams.delete('code');
			u.searchParams.delete('state');
			// const shareLink = `${u.origin}${u.pathname}${u.search}#${route.fullPath}`;
			const shareLink = `${u.origin}${u.pathname}${u.search}#/`;
			const shareConfig = {
				title: '华瑞11周年，邀你一起寻宝！',
				desc: '开启寻宝之旅，解锁千元好礼',
				link: shareLink,
				imgUrl: 'https://www.i-oranges.com/formal/hryh/20260508/shareImg.png',
				success() {

				},
			};
			wx.updateAppMessageShareData(shareConfig)
			wx.updateTimelineShareData(shareConfig)

		})

		wx.error((err) => {
			isReady = false
			console.error('wx.config error', err)
		})

		window.wx = wx
		return wx
	} catch (error) {

		console.error('initWeChatSdk failed', error)
	}
}

// ==================== 微信OAuth2授权登录 ====================

/**
 * 从URL中获取微信授权回调的code参数
 * 由于项目使用hash路由，code参数会在 window.location.search 中
 */
export const getWeChatCodeFromUrl = () => {
	const searchParams = new URLSearchParams(window.location.search)
	return searchParams.get('code') || ''
}

/**
 * 清除URL中的code和state参数（授权成功后清理URL）
 */
export const cleanWeChatCodeFromUrl = () => {
	const url = new URL(window.location.href)
	url.searchParams.delete('code')
	url.searchParams.delete('state')
	window.history.replaceState({}, '', url.toString())
}

/**
 * 跳转到微信授权页面
 * 直接前端拼接OAuth2授权地址
 */
export const redirectToWeChatAuth = () => {

	const redirectUri = getWxRedirectUri()
	const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WX_APPID}&redirect_uri=${encodeURIComponent(
		redirectUri,
	)}&response_type=code&scope=snsapi_userinfo&state=wechat_auth#wechat_redirect`
	window.location.href = authUrl
}

// 判断是否登录以及微信浏览器环境
export const handleWeChatAuth = async () => {

	const userStore = UserInfo()
	// 1. 已登录，直接返回
	if (userStore.isLoggedIn) {
		clearWxAuthFailAt()
		return true
	}

	// 2. URL中有code，用code换取用户信息
	const code = getWeChatCodeFromUrl()
	if (code) {
		try {
			// code换取openid
			const formData = new FormData()
			formData.append('code', code)
			const loginRes = await loginWx(formData)
			console.log('获取到的openidloginRes', loginRes)

			if (!loginRes || !loginRes.data) {
				// code换取失败，设置冷却期，清除跳转标志，避免死循环
				console.error('[wechat] loginWx 失败或返回空', loginRes)
				setWxAuthFailAt()
				sessionStorage.removeItem('__wx_redirecting__')
				return false
			}

			userStore.updateUserData({ md5OpenId: loginRes.data })

			// 获取用户信息
			const userInfoRes = await reqUserInfo()
			console.log('获取opendid后获取用户信息userInfoRes', userInfoRes)

			if (userInfoRes && userInfoRes.data) {
				userStore.updateUserData({
					md5OpenId: userInfoRes.data.md5OpenId,
					nickName: userInfoRes.data.nickname,
					headImg: userInfoRes.data.headImg,
					prizeId: userInfoRes.data.prizeId,
					code: userInfoRes.data.code,
					drawCount: userInfoRes.data.drawCount,
					shareCount: userInfoRes.data.shareCount,
				})
			}

			// 授权成功后清理 URL，并重新初始化 JSSDK
			cleanWeChatCodeFromUrl()
			// 授权成功，清除跳转中标志
			sessionStorage.removeItem('__wx_redirecting__')
			await initWeChatSdk(window.location.href)
			return true
		} catch (err) {
			console.error('[wechat] code换取授权异常', err)
			setWxAuthFailAt()
			sessionStorage.removeItem('__wx_redirecting__')
			return false
		}
	}

	// 3. 非微信环境，跳过授权（方便本地开发调试）
	if (!isWeChat()) {
		console.warn('非微信环境，跳过微信授权')
		return false
	}

	// 4. 微信环境且未登录，跳转授权页
	const failAt = getWxAuthFailAt()
	if (failAt && Date.now() - failAt < WX_AUTH_FAIL_COOLDOWN_MS) {
		// 失败冷却期内：不再自动跳转（避免重定向/刷新死循环）
		console.warn('微信授权已暂时阻止自动重定向（避免死循环）')
		return false
	}

	redirectToWeChatAuth()
	return false
}



// WEBPACK FOOTER //
// ./src/utils/wechat.js